import React, { useState, useCallback, useEffect, useRef } from 'react';
import axios from 'axios';
const Law = (searchText: string, pageNumber: number) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [ReLawArray, setReLawArray] = useState([]);
  const [hasMore, setHaseMore] = useState(false);
  useEffect(() => {
    // console.log(hasMore)
    setLoading(true);
    setError(false);
    let cancel: any;
    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_BASE_URL}/api/Admin/ListLaw?&size=30&page=${pageNumber}${searchText!==""?`&search=${searchText}`:""}`,
      // params:{page:pageNumber,search:searchText},
      cancelToken: new axios.CancelToken((c) => (cancel = c)),
    })
      .then((res) => {
        setReLawArray((ReLawArray) => {
          return new Set([
            ...ReLawArray,
            ...res.data.data.map((i) => {
              return {label:i.Title,value:i.ID,date:i.ApproveDate};
            }),
          ]);
        });
        // console.log(Array.from(res.data).length>1 ?true:false)

        if (Array.from(res.data.data).length > 1) {
          setHaseMore(true);
        } else {
          setHaseMore(false);
        }

        setLoading(false);
        // console.log("Ccc",res.data.data)
      })
      .catch((e) => {
        if (axios.isCancel(e)) return setError(e);
      });
    return () => cancel();
   
  }, [searchText, pageNumber]);
  useEffect(() => {
    setReLawArray([]);
  }, [searchText]);
  return { loading, error, ReLawArray, hasMore };
};

export default Law;
